import * as types from "../types/systemBranches"
import { getBranches } from "services"

export const fetchSystemBranches = () => (
  async (dispatch) => {
    try {
      const branches = await getBranches()

      dispatch({
        type: types.FETCH_SYSTEM_BRANCHES,
        branches
      })
    } catch (err) {
      console.log(err)
    }
  }
)